"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/** Styles for the overlay SVG */
var styles = function styles() {
  return {
    boxContainerLine: {
      cursor: 'pointer',
      transition: 'opacity 0.5s ease',
      fill: function fill(_ref) {
        var useAutoColors = _ref.useAutoColors,
          pageColors = _ref.pageColors,
          color = _ref.color,
          visible = _ref.visible,
          opacity = _ref.opacity;
        var c = color;
        if (useAutoColors && pageColors) {
          c = pageColors.color;
        }
        var renderOpacity = !visible ? 0 : opacity;
        renderOpacity = renderOpacity - 0.15 > 0 ? renderOpacity - 0.15 : 0;
        return (0, _colorManipulator.alpha)(c, renderOpacity);
      },
      opacity: 0,
      '&:hover': {
        opacity: 1
      }
    },
    isHighlighted: {
      opacity: 1,
      fill: function fill(_ref2) {
        var useAutoColors = _ref2.useAutoColors,
          pageColors = _ref2.pageColors,
          color = _ref2.color,
          visible = _ref2.visible,
          opacity = _ref2.opacity;
        var c = color;
        if (useAutoColors && pageColors) {
          c = pageColors.color;
        }
        var renderOpacity = !visible ? 0 : opacity;
        return (0, _colorManipulator.alpha)(c, renderOpacity);
      }
    }
  };
};

/** Page Text Display component that is optimized for fast panning/zooming
 *
 * NOTE: This component is doing stuff that is NOT RECOMMENDED GENERALLY, like
 *       hacking shouldComponentUpdate to not-rerender on every prop change,
 *       setting styles manually via DOM refs, etc. This was all done to reach
 *       higher frame rates.
 */
var PageTextDisplay = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PageTextDisplay, _React$Component);
  /** Set up refs for direct transforms and pointer callback registration */
  function PageTextDisplay(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.onPointerDown = function () {
      _this.props.viewer.gestureSettingsMouse.clickToZoom = false;
    };
    _this.onPointerUp = function () {
      _this.props.viewer.gestureSettingsMouse.clickToZoom = true;
    };
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.boxContainerRef = /*#__PURE__*/_react["default"].createRef();
    _this.lineRefs = [];
    return _this;
  }

  /** Register pointerdown handler on SVG container */
  var _proto = PageTextDisplay.prototype;
  _proto.componentDidMount = function componentDidMount() {
    // FIXME: We should be able to use React for this, but it somehow doesn't work
    this.boxContainerRef.current.addEventListener('pointerdown', this.onPointerDown);
    // For mobile Safari <= 12.2
    this.boxContainerRef.current.addEventListener('touchstart', this.onPointerDown);
  }

  /** Unregister pointerdown handler on SVG container */;
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.boxContainerRef.current.removeEventListener('pointerdown', this.onPointerDown);
    this.boxContainerRef.current.removeEventListener('touchstart', this.onPointerDown);
  }

  /** Swallow pointer events if selection is enabled */;
  /** Update the CSS transforms for the SVG container, i.e. scale and move the text overlay
   *
   * Intended to be called by the parent component. We use direct DOM access for this instead
   * of props since it is *significantly* faster (30fps vs 60fps on my machine).
   */
  _proto.updateTransforms = function updateTransforms(scaleFactor, x, y) {
    if (!this.containerRef.current) {
      return;
    }
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height;
    // Scaling is done from the center of the container, so we have to update the
    // horizontal and vertical offsets we got from OSD.
    var translateX = (scaleFactor - 1) * width / 2 + x * scaleFactor * -1;
    var translateY = (scaleFactor - 1) * height / 2 + y * scaleFactor * -1;
    var containerTransforms = ["translate(" + translateX + "px, " + translateY + "px)", "scale(" + scaleFactor + ")"];
    this.containerRef.current.style.display = null;
    this.containerRef.current.style.transform = containerTransforms.join(' ');
  }

  /** Update the opacity of the text and rects in the SVG.
   *
   * Again, intended to be called from the parent, again for performance reasons.
   */;
  _proto.updateColors = function updateColors(color, opacity) {
    if (!this.boxContainerRef.current) {
      return;
    }
    // We need to apply the colors to the individual rects and texts instead of
    // one of the containers, since otherwise the user's selection highlight would
    // become transparent as well or disappear entirely.
    for (var _iterator = _createForOfIteratorHelperLoose(this.boxContainerRef.current.querySelectorAll('rect')), _step; !(_step = _iterator()).done;) {
      var rect = _step.value;
      rect.style.fill = (0, _colorManipulator.alpha)(color, opacity);
    }
  }

  /** Render the page overlay */;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      lines = _this$props2.lines,
      canvasId = _this$props2.canvasId,
      pageWidth = _this$props2.width,
      pageHeight = _this$props2.height,
      classes = _this$props2.classes,
      doHighlightLine = _this$props2.doHighlightLine,
      skipEmptyLines = _this$props2.skipEmptyLines;
    var containerStyle = {
      // This attribute seems to be the key to enable GPU-accelerated scaling and translation
      // (without using translate3d) and achieve 60fps on a regular laptop even with huge objects.
      willChange: 'transform',
      position: 'absolute',
      display: 'none' // will be cleared by first update
    };

    var svgStyle = {
      left: 0,
      top: 0,
      width: pageWidth,
      height: pageHeight,
      userSelect: 'none',
      whiteSpace: 'pre'
    };
    var renderLines = !skipEmptyLines || lines.filter(function (l) {
      return l.width > 0 && l.height > 0 && l.text.trim().length > 0;
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: this.containerRef,
      style: containerStyle
    }, /*#__PURE__*/_react["default"].createElement("svg", {
      className: classes.boxContainer,
      style: _extends({}, svgStyle, {
        userSelect: 'none'
      })
    }, /*#__PURE__*/_react["default"].createElement("g", {
      ref: this.boxContainerRef
    }, renderLines.map(function (line, index) {
      return /*#__PURE__*/_react["default"].createElement("rect", {
        ref: function ref(_ref3) {
          _this2.lineRefs[index] = _ref3;
          return true;
        },
        className: classes.boxContainerLine + " " + (line.isHighlighted ? classes.isHighlighted : ''),
        key: "rect-" + line.x + "." + line.y,
        x: line.x,
        y: line.y,
        width: line.width,
        height: line.height,
        onClick: function onClick() {
          doHighlightLine(canvasId, line, 'overlay');
        }
      });
    }))));
  };
  return PageTextDisplay;
}(_react["default"].Component);
PageTextDisplay.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes["default"].objectOf(_propTypes["default"].string),
  visible: _propTypes["default"].bool.isRequired,
  opacity: _propTypes["default"].number.isRequired,
  color: _propTypes["default"].string.isRequired,
  useAutoColors: _propTypes["default"].bool.isRequired,
  width: _propTypes["default"].number.isRequired,
  height: _propTypes["default"].number.isRequired,
  canvasId: _propTypes["default"].string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  lines: _propTypes["default"].array.isRequired,
  source: _propTypes["default"].string.isRequired,
  doHighlightLine: _propTypes["default"].func.isRequired,
  viewer: _propTypes["default"].object,
  highlightedLine: _propTypes["default"].object,
  // eslint-disable-next-line react/forbid-prop-types
  pageColors: _propTypes["default"].object,
  skipEmptyLines: _propTypes["default"].bool
} : {};
PageTextDisplay.defaultProps = {
  classes: {},
  pageColors: undefined,
  highlightedLine: null
};
var _default = (0, _withStyles["default"])(styles)(PageTextDisplay);
exports["default"] = _default;